import { createRoot } from 'react-dom/client';
import { App } from './app';

// Handle Vite dynamic import errors (e.g., stale chunks after new deployment).
// When an old bundle tries to load a removed module, this event fires.
// We reload the page to load the latest assets and recover gracefully.
window.addEventListener('vite:preloadError', (event: Event) => {
  console.error('[vite:preloadError]');
  // prevent the error from bubbling
  event.preventDefault();
  event.stopImmediatePropagation();

  // forcing page refresh to load the latest assets
  window.location.reload();
});

// dynamic import failures
window.addEventListener('unhandledrejection', (event) => {
  const msg =
    typeof event.reason === 'string'
      ? event.reason
      : event?.reason?.message || '';

  const errorMessagesToIgnore = [
    'Failed to fetch dynamically imported module',
    'Importing a module script failed',
    "'Route' of 'undefined'",
    'Failed to load module script:',
    'Loading chunk',
    'ChunkLoadError',
  ];

  const shouldIgnore = errorMessagesToIgnore.some((message) =>
    msg.includes(message)
  );

  if (shouldIgnore) {
    const lastReload = parseInt(
      sessionStorage.getItem('lastDynamicImportReload') || '0',
      10
    );
    const now = Date.now();

    // Using sessionStorage to track last reload time to prevent potential infinite reload loops
    if (now - lastReload > 60_000) {
      sessionStorage.setItem('lastDynamicImportReload', now.toString());

      event.preventDefault();
      event.stopImmediatePropagation();

      window.location.reload();
    } else {
      console.warn('Skipping reload to prevent loop.');
    }
  }
});

createRoot(document.getElementById('root')!).render(<App />);
